import { render } from "./InAppProductsListEditorCmp.vue?vue&type=template&id=5cb95fa0"
import script from "./InAppProductsListEditorCmp.vue?vue&type=script&lang=js"
export * from "./InAppProductsListEditorCmp.vue?vue&type=script&lang=js"

import "./InAppProductsListEditorCmp.vue?vue&type=style&index=0&id=5cb95fa0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__